import { c as _c } from "react/compiler-runtime";
import { Button } from "@heroui/react";
import { ButtonOverride } from "./ButtonOverride";
import { cn } from "@/util/cn";
export default function RainbowButton(props) {
  const $ = _c(9);
  let t0;
  if ($[0] !== props.className) {
    t0 = cn("rainbow-wrapper align-middle justify-center", props.className);
    $[0] = props.className;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.children) {
    t1 = <div className="flex rainbow-content-lg align-middle justify-center h-full w-full"><span className="mt-[9px]">{props.children}</span></div>;
    $[2] = props.children;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props.disabled || $[5] !== props.onClick || $[6] !== t0 || $[7] !== t1) {
    t2 = <Button variant="solid" color="primary" className={t0} onPress={props.onClick} disabled={props.disabled}>{t1}</Button>;
    $[4] = props.disabled;
    $[5] = props.onClick;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}